export const enum IndividualDesignationListedTypes {
  BENEFICIARY = 'BENEFICIARY',
  EXECUTOR = 'EXECUTOR',
  NOTSURE = 'NOTSURE',
  EMPTY = '',
}
